import React, { Component } from 'react';
import assigned from '../images/assigned.png';
import picked from '../images/picked.png';
import completed from '../images/completed.png';
const NoDataComponent=props=> {
    return (
      <div className="nojobs">
        <div>
          <img src={props.nodata==='assigned' ? assigned : props.nodata==='intansit' ? picked : completed} alt="no-jobs"/>
          <div className='text-center'>{props.nodata==='completed' ? 'No Completed Jobs' : <div>No jobs {props.nodata} to deliver</div>}</div>
        </div>

      </div>
    );
}
export default NoDataComponent;



// WEBPACK FOOTER //
// ./src/components/NoDataComponent.js